import { render, staticRenderFns } from "./Productos.View.vue?vue&type=template&id=c527217c&"
import script from "./Productos.View.vue?vue&type=script&lang=js&"
export * from "./Productos.View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports